import classnames from "classnames";
import { useDropdown } from "@/hooks";
import styles from "@/styles/DropdownMenu.module.scss";

export default function DropdownMenu({
  mouseOver = false,
  right = false,
  button,
  children,
  scopedClass,
}) {
  const { buttonRef, contentRef, show, listeners } = useDropdown({ mouseOver });
  return (
    <div
      className={`${styles.dropdown} ${scopedClass}`}
      onMouseOver={listeners.handleMouseOver}
      onMouseLeave={listeners.handleMouseLeave}
    >
      <div
        ref={buttonRef}
        className={classnames(styles.button, scopedClass, {
          [styles.show]: show,
        })}
        onClick={listeners.handleClick}
      >
        {button}
      </div>
      <div
        ref={contentRef}
        className={classnames(styles.content, scopedClass, {
          [styles.show]: show,
          [styles.right]: right,
        })}
      >
        {children}
      </div>
    </div>
  );
}
